import sanitizeHtml from 'sanitize-html';

const CODE_FENCE_RE = /^\s*```[a-zA-Z0-9_-]*\s*\n?([\s\S]*?)\n?\s*```\s*$/;

/** A Q&A answer is model-written HTML, sometimes wrapped in a code fence; unwrap and sanitize it. */
export const qaAnswerHtml = (answer) => {
  if (typeof answer !== 'string') return '';
  const fenceMatch = answer.match(CODE_FENCE_RE);
  const raw = fenceMatch ? fenceMatch[1].trim() : answer.trim();
  return sanitizeHtml(raw, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['h1', 'h2', 'span']),
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      a: ['href', 'target', 'rel'],
      '*': ['class'],
    },
  });
};
